var _jsxFileName = "/Users/pjreed/dev/mirador/dist/es/src/components/AccessTokenSender.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import IframeComm from 'react-iframe-comm';
/**
 * Opens a new window for click
 */

export var AccessTokenSender =
/*#__PURE__*/
function (_Component) {
  _inherits(AccessTokenSender, _Component);

  /** */
  function AccessTokenSender(props) {
    var _this;

    _classCallCheck(this, AccessTokenSender);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AccessTokenSender).call(this, props));
    _this.onReceiveAccessTokenMessage = _this.onReceiveAccessTokenMessage.bind(_assertThisInitialized(_this));
    return _this;
  }
  /** @private */


  _createClass(AccessTokenSender, [{
    key: "onReceiveAccessTokenMessage",
    value: function onReceiveAccessTokenMessage(e) {
      var _this$props = this.props,
          handleAccessTokenMessage = _this$props.handleAccessTokenMessage,
          url = _this$props.url;
      if (e.data && e.data.messageId && e.data.messageId === url) handleAccessTokenMessage(e.data);
    }
    /** */

  }, {
    key: "render",
    value: function render() {
      var url = this.props.url;
      if (!url) return React.createElement(React.Fragment, null);
      /**
      login, clickthrough/kiosk open @id, wait for close
      external, no-op
      */

      return React.createElement(IframeComm, {
        attributes: {
          src: "".concat(url, "?origin=").concat(window.origin, "&messageId=").concat(url)
        },
        handleReceiveMessage: this.onReceiveAccessTokenMessage,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 32
        },
        __self: this
      });
    }
  }]);

  return AccessTokenSender;
}(Component);
AccessTokenSender.defaultProps = {
  url: undefined
};